import { postReq } from '../services/http';

// Request helpers
export const requestUserColors = async () => {
	const res = await postReq('/interface/user_colors/list', {});

	if (res.isok) {
	} else {
		console.error('could not get user saved colors');
	}

	return res?.data?.color_list?.colors;
};
